import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// Erlaubt einzelnen Seiten (z.B. dem Buchungsprozess), die Footer-Leiste im
// empty-Layout fixiert darzustellen, ohne das Layout für andere Seiten zu ändern.
@Injectable({
    providedIn: 'root',
})
export class LayoutChromeService {
    private _stickyFooter$ = new BehaviorSubject<boolean>(false);
    readonly stickyFooter$ = this._stickyFooter$.asObservable();

    setStickyFooter(sticky: boolean): void {
        this._stickyFooter$.next(sticky);
    }
}
